function MainLink() {
    const link = "https://api.medieval-rp.net/";
    return link;
}

export default MainLink;
